<script setup>
// RM-360 / RM-359 (Kapil 10/27): "See what {restaurant} will receive" as a
// small preview card — like the link preview a phone shows under the texted
// preview link — instead of a line of link text. Tapping it opens the preview.
defineProps({
  label: { type: String, required: true },
  loading: { type: Boolean, default: false },
})
defineEmits(['open'])
</script>

<template>
  <button
    type="button"
    class="request-preview-card"
    :aria-busy="loading"
    @click="$emit('open')"
  >
    <span class="request-preview-card__thumb">
      <VProgressCircular
        v-if="loading"
        indeterminate
        size="20"
        width="2"
      />
      <VIcon
        v-else
        icon="mdi-email-open-outline"
        size="22"
      />
    </span>
    <span class="request-preview-card__text">
      <span class="request-preview-card__title">{{ label }}</span>
      <span class="request-preview-card__sub">Their email and request page, as they'll get it</span>
    </span>
    <VIcon
      icon="mdi-chevron-right"
      size="20"
      class="request-preview-card__chevron"
    />
  </button>
</template>

<style scoped>
.request-preview-card {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px;
  border: 1px solid var(--ds-border-light);
  border-radius: 12px;
  background: var(--ds-surface-card);
  text-align: left;
  cursor: pointer;
  transition: border-color 150ms ease;
}

.request-preview-card:hover,
.request-preview-card:focus-visible {
  border-color: rgb(var(--v-theme-primary));
  outline: none;
}

.request-preview-card__thumb {
  display: flex;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(var(--v-theme-primary), 0.1);
  color: rgb(var(--v-theme-primary));
}

.request-preview-card__text {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.request-preview-card__title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--ds-text-strong);
}

.request-preview-card__sub {
  font-size: 12px;
  line-height: 1.3;
  color: var(--ds-text-secondary);
}

.request-preview-card__chevron {
  color: var(--ds-text-secondary);
}
</style>
